import { DateTime } from 'luxon';

import { locationAdapter } from '@/adapters/locations';
import { ticketAdapter } from '@/adapters/ticket';

const routeGroupAdapter = (data) => {
  return {
    id: data.ID,
    name: data.Name,
  };
};

export const routeAdapter = (data) => {
  const { train, carrier } = data;

  return {
    id: data.id,

    departureLocation: locationAdapter(data.departure_location),
    departsAt: data.departs_at,

    arrivalLocation: locationAdapter(data.arrival_location),
    arrivesAt: data.arrives_at,

    train: train && {
      code: train.code,
      type: train.type,
    },

    distance: data.distance,
    duration: data.duration,

    carrier: carrier && {
      id: carrier.id,
      name: carrier.name,
      image: carrier.image,
    },

    groups: data.groups?.map(routeGroupAdapter),
    tickets: data.tickets?.map(ticketAdapter),
  };
};

export const routesAdapter = (items) => {
  return items.map(routeAdapter);
};

export const routeDatePreviewAdapter = (data) => {
  return {
    date: data.date,
    price: data.price, // currencies object { cad: 25.15 }
  };
};

export const routeDatePreviewsAdapter = (items) => {
  return items.map(routeDatePreviewAdapter);
};

// RN source: src/helpers/getCheapestRoutes.js
export const routesWithLabelsAdapter = (routes) => {
  let lowerPrice = 0;
  let lowerTicketIds = [];
  let fastestTime = 0;
  let fastestTimeIds = [];
  let hasHigherPrice = false;

  routes.forEach((route, index) => {
    let price = route.tickets?.[0]?.price?.['usd'];
    let duration = route.duration;

    if (duration < fastestTime || index === 0) {
      fastestTime = duration;
      fastestTimeIds = [route.id];
    } else if (duration === fastestTime) {
      fastestTimeIds.push(route.id);
    }

    if (price < lowerPrice || index === 0) {
      lowerPrice = price;
      lowerTicketIds = [route.id];
    } else if (price === lowerPrice) {
      lowerTicketIds.push(route.id);
    } else if (price > lowerPrice) {
      hasHigherPrice = true;
    }
  });

  return routes.map((route) => {
    return {
      ...route,
      isCheapest: hasHigherPrice && lowerTicketIds.includes(route.id),
      isFastest: fastestTimeIds.includes(route.id),
      hasHigherPrice,
    };
  });
};
